import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { CardInfoParam } from "src/components/Card/CardInfoParam";
import { infoParamsTrns } from "src/components/CloneCard/trns";
import { PATHNAMES } from "src/constants/routes";
import { combineSlugId } from "src/utils/combineSlugId";
import { getItemPath } from "src/utils/getItemPath";

interface Props {
  profileSlug: string;
  profileId: number;
  profile: string;
  address: string;
  phone: string;
  website: string;
}

export const Contacts: FC<Props> = ({
  profile,
  profileSlug,
  profileId,
  address,
  phone,
  website,
}) => {
  const { t } = useTranslation();
  const combinedProfileSlugId = combineSlugId(profileSlug, profileId);

  return (
    <div className="flex flex-col gap-1">
      <CardInfoParam
        label={t(infoParamsTrns.profile)}
        href={getItemPath(PATHNAMES.USER_PROFILE, {
          id: combinedProfileSlugId,
        })}
        isExternalLink={false}
      >
        {profile}
      </CardInfoParam>

      <CardInfoParam label={t(infoParamsTrns.address)}>{address}</CardInfoParam>

      <CardInfoParam label={t(infoParamsTrns.phone)} href={`tel:${phone}`}>
        {phone}
      </CardInfoParam>

      <CardInfoParam
        label={t(infoParamsTrns.website)}
        href={website}
        isOpenNewTab
        className="overflow-hidden"
      >
        {website}
      </CardInfoParam>
    </div>
  );
};
